<lcs-loading-overlay [show]="loading | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">Can't Sign in?</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onClose()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" autocomplete="off" (ngSubmit)="onSave()">
      <mat-dialog-content>
         <p>
            Please enter your Email and submit the password reset request. You'll receive a notification to the E-mail
            address.
         </p>
         <p> Follow the instructions on the E-mail to reset your User password. </p>
         <mat-form-field>
            <mat-label>Email</mat-label>
            <input id="emailAddress" matInput type="text" formControlName="emailAddress" required />
         </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="submit" title="Create" mat-raised-button>Send</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
